import { decode } from "html-entities";

const INC_PRICE = "INC_PRICE";

const DESC_PRICE = "DESC_PRICE";

const INC_ALPHABET = "INC_ALPHABET";

const DESC_ALPHABET = "DESC_ALPHABET";

const INC_DATE = "INC_DATE";

const DESC_DATE = "DESC_DATE";

const MAX_PRICE = 1000000;

const EmptyImage =
  "https://res.cloudinary.com/billsclan/image/upload/v1660037737/AppIcons/ho3s4xxadnxupyzmak8y_itcpfn.png";

const CurrencyType = {
  ngn: decode("&#8358;"),
  usd: "$",
};

export const siteSlug = window.location.pathname.split("/")?.[1] || "default";

// const DEFAULT_THEME = "billshop-theme-default"
const DEFAULT_THEME = "billshop-theme-default";
const DEFAULT_FAVICON =
  "https://billsclan.com/external/landing/image/png/favicon.png";

export const INDEX_STATE = {
  FILTER: "filter",
  SEARCH: "search",
  ALL: "all",
};

class themeObject {
  constructor(backgroundColor, color) {
    this.backgroundColor = backgroundColor;
    this.color = color;
  }
}

const getThemeColor = (value) => {
  switch (value) {
    case "billshop-theme-red":
      return new themeObject("#d91e18", "#fff");
    case "billshop-theme-blue":
      return new themeObject("#038aff", "#fff");
    case "billshop-theme-green":
      return new themeObject("#26c281", "#fff");
    case "billshop-theme-purple":
      return new themeObject("#284387", "#fff");
    case "billshop-theme-orange":
      return new themeObject("#f9690e", "#fff");
    case "billshop-theme-pink":
      return new themeObject("#db0a5b", "#fff");

    default:
      return new themeObject("#000", "#fff");
  }
};

export const parseCountries = (countries) => {
  return countries.map((el) => ({ label: el, value: el }));
};

export const parseDeliveryOptions = (options) => {
  return options.map((el) => ({
    ...el,
    label: `${el.deliveryLocation} - ${el.deliveryDuration} days`,
    value: el.deliverySetupId,
  }));
};

export {
  INC_ALPHABET,
  INC_DATE,
  INC_PRICE,
  DESC_ALPHABET,
  DESC_DATE,
  DESC_PRICE,
  MAX_PRICE,
  DEFAULT_FAVICON,
  getThemeColor,
  DEFAULT_THEME,
  EmptyImage,
  CurrencyType,
};
